import React, { useState } from 'react';
import { Box, Grid, TextField, Button } from '@mui/material';

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e =>
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      setSubmitting(true);
      setError('');
      const res = await fetch(`${API_BASE}/contact_message.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.ok === false) throw new Error(json.error || `HTTP ${res.status}`);
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Unable to send your message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        Thank you for your message! We’ll get back to you soon.
      </Box>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit}>
      {error && <Box sx={{ mb: 2, color: 'error.main' }}>{error}</Box>}
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            required
            label="Name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            required
            label="Email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
          />
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            required
            label="Message"
            name="message"
            multiline
            rows={4}
            value={form.message}
            onChange={handleChange}
          />
        </Grid>
        <Grid size={12}>
          <Button type="submit" variant="contained" disabled={submitting}>
            {submitting ? 'Sending…' : 'Send Message'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
